import * as React from 'react';
import './HTMLEditorQuillForMatchReport.css';
import { FunctionComponent } from 'react';
import { HTMLEditorQuill } from './HTMLEditorQuill';
import { AppUser } from 'Src/views/App/App';

interface Props {
  user?: AppUser;
  onTextMatchReportChange: (editorState: any) => void;
  value: string;
  isEnabled: boolean;
  isEnabledEditorActiveToolbar: boolean;
  placeholder: string;
}

export const HTMLEditorQuillForMatchReport: FunctionComponent<Props> = props => {
  return (
    <HTMLEditorQuill
      user={props.user}
      placeholder={props.placeholder}
      onEmailBodyChange={props.onTextMatchReportChange}
      value={props.value}
      isEnabled={props.isEnabled}
      isToolbarVisible={props.isEnabledEditorActiveToolbar}
    />
  );
};

HTMLEditorQuillForMatchReport.displayName = 'HTMLEditorQuillForMatchReport';
